var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47243 3.53539V2.23633C7.43963 2.35301 5.53332 3.14294 4.01172 4.49902L6.36494 6.85224C6.9151 6.39422 7.53852 6.04888 8.20674 5.82782C8.30834 5.35159 8.39634 4.95127 8.45543 4.68535C8.5775 4.136 8.96791 3.71152 9.47243 3.53539Z",
    fill: "#09A0D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61925 7.59732L3.26606 5.24414C1.90882 6.76531 1.11791 8.67176 1.00049 10.705H4.32898C4.43445 9.55822 4.88093 8.48283 5.61925 7.59732Z",
    fill: "#09A0D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6711 10.705H18.9996C18.8822 8.67176 18.0913 6.76531 16.734 5.24414L14.3809 7.59732C15.1192 8.48279 15.5657 9.55822 15.6711 10.705Z",
    fill: "#09A0D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6705 11.7598C15.4961 13.6757 14.4443 14.8447 14.0268 15.2622C13.8205 15.4685 13.8205 15.803 14.0268 16.0093L15.6268 17.6094C15.73 17.7126 15.8652 17.7641 16.0004 17.7641C16.1356 17.7641 16.2707 17.7126 16.3739 17.6094C17.9532 16.0302 18.8741 13.9695 19.0002 11.7598H15.6705Z",
    fill: "#09A0D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32965 11.7598H1C1.12604 13.9695 2.04695 16.0302 3.62628 17.6095C3.72943 17.7126 3.8646 17.7642 3.99978 17.7642C4.13495 17.7642 4.27016 17.7126 4.37331 17.6095L5.97334 16.0093C6.17961 15.803 6.17961 15.4685 5.97334 15.2622C5.55579 14.8447 4.50402 13.6757 4.32965 11.7598Z",
    fill: "#09A0D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 2.23633V3.53542C11.0319 3.71156 11.4223 4.13603 11.5443 4.68542C11.6034 4.95134 11.6914 5.35163 11.793 5.82786C12.4613 6.04895 13.0847 6.39426 13.6348 6.85227L15.9881 4.49905C14.4665 3.1429 12.5601 2.35301 10.5273 2.23633Z",
    fill: "#09A0D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 4.50098C9.75268 4.50098 9.53865 4.67264 9.48504 4.91392C9.36811 5.44003 8.34277 10.0873 8.34277 11.2416C8.34277 12.1553 9.08612 12.8986 9.99979 12.8986C10.9135 12.8986 11.6568 12.1553 11.6568 11.2416C11.6568 10.0873 10.6315 5.44003 10.5146 4.91392C10.461 4.67264 10.247 4.50098 9.99983 4.50098Z",
    fill: "#09A0D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.08a639a9342aed8d572ef4ed112f03a1.svg";
export { ForwardRef as ReactComponent };